$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p == "organizer_product_group" && a == "list") {
    let product_group_new_ajax_lock = false;

    $(document).on("submit", "#product-group-registration-form", function () {
      if (!product_group_new_ajax_lock) {
        product_group_new_ajax_lock = true;

        let url;
        if (
          $("#product-group-registration-form input[name=product_group_id]")
            .length
        ) {
          url = "/ajax/organizer_product_group/update";
        } else {
          url = "/ajax/organizer_product_group/new";
        }
        $.ajax({
          type: "POST",
          url: url,
          data: {
            serialized_post: $(this).serialize(),
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              popupAlert();
              $("#product-group-list").empty();
              $("#product-group-list").append(data.html);
              if (
                $("#show-deactivated-product-group-button").hasClass("d-none")
              ) {
                $("#show-deactivated-product-group-button").removeClass(
                  "d-none",
                );
              }
              $("#product-group-registration-form-modal").modal("hide");
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              prependAlert(
                "#product-group-registration-button-wrapper",
                data.responseJSON.error_message,
                "danger",
                null,
                "#product-group-registration-form",
              );
            }

            product_group_new_ajax_lock = false;
          })
          .always(function () {
            product_group_new_ajax_lock = false;
          });
      }

      return false;
    });
  }
});
